/**
 * CRM and portal header menu labels. Shared by toolbar `description`, route
 * `title`, and browser tab titles.
 */
export const MenuItemsConstants = {
  portal: {
    yourEvents: 'Your Events',
    eventRegistration: 'Event Registration',
    dashboard: 'Dashboard',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    components: 'Components',
    communications: 'Communications',
    grids: 'Grids',
    stats: 'Stats',
    agent: 'Agent',
    teamManagement: 'Team Management',
    contactManagement: 'Agent Administration',
    auth: {
      login: 'Login',
      register: 'Register',
      agentUnderReview: 'Under Review',
    },
    adminTools: {
      adminTools: 'Admin Tools',
      settings: 'Settings',
      goals: 'Goals',
      errors: 'Errors',
      content: 'Content',
      announcements: 'Announcements',
      calendar: 'Calendar',
      cards: 'Cards',
      cardsAdministration: 'Cards Administration',
      cardMaker: 'Card Maker',
      cardViewer: 'Card Viewer',
      forms: 'Forms',
      formMaker: 'Form Maker',
      formViewer: 'Form Viewer',
      formResults: 'Form Results',
      macros: 'Macros',
      menu: 'Menu',
      pages: 'Pages',
      pageMaker: 'Page Maker',
      pageViewer: 'Page Viewer',
      splashScreens: 'Splash Screens',
      videos: 'Videos',
      pageBuilder: 'Page Builder',
      blockTemplates: 'Block Templates',
      globalTemplates: 'Global Templates',
      formsBuilder: 'Forms Builder',
      store: 'Store',
      storeOrders: 'Orders',
      storeOrderDetails: 'Order Details',
      storeCheckout: 'Checkout',
      storeCart: 'Cart',
      storeProducts: 'Products',
      storeProductDetail: 'Product Detail',
      storeProductMaker: 'Product Maker',
      coupons: 'Coupons',
    },
    userMenu: {
      profile: 'Profile',
      myCampaign: 'My Campaign',
      myEvents: 'My Events',
      myOrders: 'My Orders',
      orderDetails: 'Order Details',
      myAgency: 'My Agency',
      myReports: 'My Reports',
      myTeam: 'My Team',
      myContests: 'My Contests',
      logout: 'Logout',
    },
  },
  crm: {
    dashboard: {
      dashboard: 'Dashboard',
    },
    contacts: {
      contacts: 'Contacts',
      agents: 'Agents',
      agentsIssues: 'Agents Issues',
      agentManagement: 'Agent Management',
      agencies: 'Agencies',
      agenciesList: 'List',
      agencyHierarchyAdministration: 'Hierarchy Administration',
      agencyManagement: 'Agency Management',
      carriers: 'Carriers',
      carrierManagement: 'Carrier Management',
      prospects: 'Prospects',
      prospectManagement: 'Prospect Management',
      registrants: 'Registrants',
    },
    registrations: {
      registrations: 'Registrations',
      events: 'Events',
      eventRegistrations: 'Event Registrations',
    },
    notificationsHub: {
      notificationsHub: 'Notifications Hub',
      notificationsTemplates: 'Notifications Templates',
      emailTemplates: 'Email Templates',
      emailTemplateEditor: 'Email Template Editor',
      templates: 'Templates',
      blocks: 'Blocks',
      globalBlocks: 'Global Blocks',
      notificationsChannels: 'Notifications Channels',
      notificationsScheduler: 'Notifications Scheduler',
      listsAndSegments: 'Lists and Segments',
      lists: 'Lists',
      segments: 'Segments',
    },
    campaigns: {
      campaigns: 'Campaigns',
      campaignServices: 'Campaign Services',
      taskBoard: 'Task Board',
      taskGrid: 'Task Grid',
    },
    reports: {
      reports: 'Reports',
      carriersProductionReporting: 'Carriers Production Reporting',
      weeklyImports: 'Weekly Imports',
      carrierProductionWorkflow: 'Carrier Production Workflow',
      reportsViewer: 'Reports Viewer',
      comparisonDashboard: 'Comparison Dashboard',
      productionHistory: 'Production Tracking',
      productionReportViewer: 'Production Report Viewer',
      mgaPaid: 'MGA Paid',
      personalPaid: 'Personal Paid',
      rmdPaid: 'RMD Paid',
      mgaSubmit: 'MGA Submit',
      personalSubmit: 'Personal Submit',
      rmdSubmit: 'RMD Submit',
      overrides: 'Overrides',
      overrideDefinition: 'Override Definition',
      agencyMappings: 'Agency Mappings',
      reportTemplates: 'Report Templates',
      overrideReportingSessions: 'Override Reporting Sessions',
      productionData: 'Production Data',
      masterPaid: 'Master Paid',
      masterSubmit: 'Master Submit',
      products: 'Products',
      supportingTables: 'Supporting Tables',
      reconciliation: 'Reconciliation',
      dashboardProductionData: 'Dashboard Production Data',
      agentIds: 'Agent IDs',
      downlineFiles: 'Downline Files',
      leadersBulletins: 'Leaders Bulletins',
      fileCompareTool: 'File Compare Tool',
      formsManagement: 'Forms Management',
      formsList: 'Forms List',
      formSubmits: 'Form Submits',
    },
    administration: {
      administration: 'Administration',
      userRoles: 'User Roles',
      assignment: 'Assignment',
      management: 'Management',
      taskLists: 'Task Lists',
      importRules: 'Import Rules',
      lookupsManager: 'Lookups Manager',
      errorsManager: 'Errors Manager',
      logsManager: 'Logs Manager',
      reportsManager: 'Reports Manager',
      salesGoals: 'Sales Goals',
      agentGoals: 'Agent Goals',
      mgaGoals: 'MGA Goals',
      googleAuthManagement: 'Google Auth Management',
      authStats: 'Auth Stats',
      agentMergeTool: 'Agent Merge Tool',
      addressesManagement: 'Addresses Management',
      usersAgreements: 'Users Agreements',
      masterVersionsList: 'Master Versions List',
      subversionsList: 'Subversions List',
    },
    userMenu: {
      profile: 'Profile',
      logout: 'Logout',
    },
    auth: {
      login: 'Login',
    },
    app: {
      home: 'Home',
      accessDenied: 'Access Denied',
    },
  },
} as const;
